import { Toaster as SonnerToaster } from 'sonner';

import useStyles from './Toaster.styles';

// This component allows us to modify the styles of the Sonner Toaster component.
const Toaster = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.toaster}>
      <SonnerToaster position="bottom-center" />
    </div>
  );
};

export default Toaster;
